import FetchWrapper from '@mv-submodules/inplant-core-fe/functions/fetch-wrapper'

export { loginUser, logoutUser } from './auth'

export const API  = () => FetchWrapper.getInstance('auth')
